import request from "@/axios";

export const getActivityList = query => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/page",
    method: "GET",
    params: {
      ...query
    }
  });
};

// 增加/编辑赠品活动
export const createActivity = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/submit",
    method: "POST",
    data
  });
};

// 删除赠品活动
export const deleteActivities = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/remove",
    method: "POST",
    params: data
  });
};

// 获取渠道数据
export const getChannels = query => {
  return request({
    url: "/lebo-trade/common/app-channel/list",
    method: "GET",
    params: query
  });
};

// 获取全部渠道数据
export const getAllChannels = query => {
  return request({
    url: "/lebo-resource/common/channel/list",
    method: "GET",
    params: query
  });
};

// 查询商品下拉数据
export const getProductList = () => {
  const path = "/lebo-trade/common/old-product/list";
  return request({
    url: path,
    method: "GET"
  });
};

// 查询短信模板
export const getSMSTemplates = () => {
  return request({
    url: "/lebo-resource/sms/all-list",
    method: "GET"
  });
};

// 保存活动数据
export const submitActivityForm = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/submit",
    method: "POST",
    data
  });
};

// 提交审核
export const handupApprove = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/apply-examine",
    method: "POST",
    data
  });
};

// 审核操作
export const submitApprove = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/submit-examine",
    method: "POST",
    data
  });
};

// 获取日志
export const getApproveLogs = query => {
  return request({
    url: "/lebo-desk/review-biz/list-examine",
    method: "GET",
    params: query
  });
};

// 获取大数据用户标签
export const getBigDataTags = () => {
  return request({
    url: "/lebo-resource/common/allUserTags",
    method: "GET"
  });
};
/** 导入手机号列表 */
export const importPhoneList = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/importPhone",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
/** 下载手机号文件 */
export const downloadPhoneFile = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/exportPhone",
    method: "get",
    params: {
      uuid: data
    },
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/octet-stream"
    }
  });
};

/** 获取业务字典中的发端类型 */
export const getProtocolSendType = () => {
  return request({
    url: "/lebo-system/dict/dictionary",
    method: "get",
    params: {
      code: "send_platform"
    }
  });
};

/** 获取业务字典中的收端类型 */
export const getProtocolReceiveType = () => {
  return request({
    url: "/lebo-system/dict/dictionary",
    method: "get",
    params: {
      code: "receive_platform"
    }
  });
};

/** 获取优惠券 */
export const getCouponList = () => {
  return request({
    url: "/lebo-partner/partnergift/page",
    method: "get",
    params: {
      current: 1,
      size: 999,
      giftType: 4,
      type: 1
    }
  });
};

/** 获取tag为优惠券的资源组以及资源位 */
export const getResourceGroup = () => {
  return request({
    url: "/lebo-desk/appresourceitem/tag",
    method: "get",
    params: {
      tagName: "7"
    }
  });
};

/** 获取加购活动的赠品 */
export const getAdditionalGood = () => {
  return request({
    url: "/lebo-partner/partnergift/page",
    method: "get",
    params: {
      current: 1,
      size: 999,
      type: 1
    }
  });
};

/** 获取加购活动的活动商品 */
export const getActivityGoods = () => {
  return request({
    url: "/lebo-member/web/member/goods/type-to-goods",
    method: "get"
  });
};

/** 查询加购活动商品是否已绑定活动 */
export const checkGoods = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/precheck",
    method: "get",
    params: data
  });
};

/** 查询活动投放的礼品信息 */
export const getPromotinSendInfo = data => {
  return request({
    url: "/lebo-partner/partnergiftpromotion/getSendInfo",
    method: "get",
    params: data
  });
};
